import { LogOut } from 'lucide-react';

import { MobileNav } from './mobile-nav';

import { DataFreshness } from '@/components/privacy/data-freshness';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/use-auth';
import { useAuthStore } from '@/stores/auth-store';


export function Header() {
  const user = useAuthStore((s) => s.user);
  const { logout } = useAuth();

  return (
    <header className="relative flex h-14 items-center justify-between border-b bg-card px-4 lg:px-6">
      <div className="flex items-center gap-2">
        <MobileNav />
        <span className="text-lg font-bold text-primary lg:hidden">Metaonia</span>
      </div>
      <div className="flex items-center gap-4">
        <DataFreshness />
        <span className="hidden text-sm text-muted-foreground sm:inline">
          {user?.first_name} {user?.last_name}
        </span>
        <Button variant="ghost" size="sm" onClick={logout}>
          <LogOut className="mr-2 h-4 w-4" />
          Sign Out
        </Button>
      </div>
    </header>
  );
}
